export default function headerMenuDropdownAnim() {

	const menuItemsL1 = document.querySelectorAll('.header-desktop ul.menu-l1 > li');
	const menuItemsL2 = document.querySelectorAll('.header-desktop ul.menu-l2 > li');

	menuItemsL1.forEach(item => {

		const anchorLink = item.querySelector('a');
		anchorLink.addEventListener('mouseenter', function () {

			const submenu = item.querySelector('.menu-submenu-nav');

			document.querySelectorAll('.header-desktop ul.menu-l1 > li .menu-submenu-nav').forEach(sub => {
				sub.style.display = 'none';
			});

			if (submenu) {
				submenu.style.display = 'grid';
			}
		});
	});

	menuItemsL2.forEach(item => {

		const anchorLink = item.querySelector('a');
		anchorLink.addEventListener('mouseenter', function () {
			console.log('hovered');
			const submenu = item.querySelector('.menu-submenu-nav');

			document.querySelectorAll('.header-desktop ul.menu-l2 > li .menu-submenu-nav').forEach(sub => {
				sub.style.display = 'none';
			});

			if (submenu) {
				submenu.style.display = 'grid';
			}
		});
	});
}
